/* tslint:disable:max-line-length */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "master",
    title: "Master",
    type: "collapsable",
    icon: "heroicons_outline:user-group",
    children: [
      {
        id: "master.admin",
        title: "Admin",
        type: "collapsable",
        children: [
          {
            id: "Company",
            title: "Company",
            type: "basic",
            link: "/master/company",
          },
          {
            id: "External Union",
            title: "External Union",
            type: "basic",
            link: "/master/exetrnalUnion",
          },
          {
            id: "Plant",
            title: "Plant",
            type: "basic",
            link: "/master/plant",
          },
          {
            id: "master.admin.section",
            title: "Section",
            type: "basic",
            link: "/master/section",
          },
          {
            id: "master.admin.storage",
            title: "Storage",
            type: "basic",
            link: "/master/storage",
          },
        ],
      },
      {
        id: "master.users",
        title: "Users",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "master.users.user",
            title: "User",
            type: "basic",
            icon: " ",
            link: "/master/user",
          },
          {
            id: "master.users.userRights",
            title: "User Rights",
            type: "basic",
            icon: " ",
            link: "/master/userRights",
          },
        ],
      },
      {
        id: "master.transportation",
        title: "Transportation",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "Contractor",
            title: "Contractor",
            type: "basic",
            icon: " ",
            link: "/master/contractor",
          },
          {
            id: "Route",
            title: "Route",
            type: "basic",
            icon: " ",
            link: "/master/route",
          },
          {
            id: "Vehicle",
            title: "Vehicle",
            type: "basic",
            icon: " ",
            link: "/master/vehicle",
          },
          {
            id: "TransportCost",
            title: "Transport Rate",
            type: "basic",
            icon: " ",
            link: "/master/transportcost",
          },
        ],
      },
      {
        id: "master.item",
        title: "Item",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "Item Group",
            title: "Item Group",
            type: "basic",
            icon: " ",
            link: "/master/itemgroup",
          },
          {
            id: "Unit",
            title: "Unit",
            type: "basic",
            icon: " ",
            link: "/master/unit",
          },
          {
            id: "Item",
            title: "Item",
            type: "basic",
            icon: " ",
            link: "/master/item",
          },
        ],
      },
      {
        id: "master.testing",
        title: "Testing",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "Lab Testing",
            title: "Lab Testing",
            type: "basic",
            icon: " ",
            link: "/master/labTesting",
          },
          {
            id: "Product Analysis",
            title: "Product Analysis",
            type: "basic",
            icon: " ",
            link: "/master/productAnalysis",
          },
        ],
      },
      {
        id: "master.machine",
        title: "Machine Master",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "Machine",
            title: "Machine",
            type: "basic",
            icon: " ",
            link: "/master/machine",
          },
        ],
      },
      {
        id: "master.other",
        title: "Other",
        type: "collapsable",
        // icon: 'heroicons_outline:chevron-down',
        children: [
          {
            id: "Document Center",
            title: "Document Center",
            type: "basic",
            icon: " ",
            link: "/master/documentcenter",
          },
          {
            id: "Day Open Close",
            title: "Day Open/Close",
            type: "basic",
            icon: " ",
            link: "/master/dayOpenClose",
          },
        ],
      },
      {
        id: "master.bom",
        title: "BOM",
        type: "collapsable",
        children: [
          {
            id: "fg-Bom-Transaction",
            title: "FG BOM",
            type: "basic",
            icon: "",
            link: "/master/FgBom",
          },
          {
            id: "Sfg-Bom-Transaction",
            title: "SFG BOM",
            type: "basic",
            icon: "",
            link: "/master/sfgBom",
          },
        ],
      },
    ],
  },
  {
    id: "transaction",
    title: "Transaction",
    type: "collapsable",
    icon: "heroicons_outline:newspaper",
    children: [
      {
        id: "transaction.bom.sfg-bom",
        title: "SFG BOM",
        type: "basic",
        icon: "",
        link: "/transaction/sfgBom",
      },
      {
        id: "transaction.bom.fg-bom",
        title: "FG BOM",
        type: "basic",
        icon: "",
        link: "/transaction/fgBom",
      },
      {
        id: "transaction.matReceipt",
        title: "Material Receipt",
        type: "basic",
        icon: "",
        link: "/transaction/storeRequisition"
      },
      {
        id: "transaction.prodMovement",
        title: "Product Movement",
        type: "basic",
        icon: "",
        link: "/transaction/productMovement",
      },
      {
        id: "transaction.prodSale",
        title: "Product Sale",
        type: "basic",
        icon: "",
        link: "/transaction/productSale",
      },
      {
        id: "transaction.closingStock",
        title: "Closing Stock",
        type: "basic",
        icon: "",
        link: "/transaction/closingStock",
      }, {
        id: "transaction.milkProc",
        title: "Milk Procurement",
        type: "basic",
        icon: "",
        link: "/transaction/milkProcurement",
      }
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
